import { useRef } from "react";
import { useDispatch } from "react-redux";
import { MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
import ButtonElement from "../../../Common/ButtonElement";
import { downloadFile } from "../../../utils";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { appApis } from "../../../constants";
import { getCompanies } from "../../../actions/companies";
import { toast } from "react-toastify";

const DropZone = ({ fileName, url, setError, inventoryTypeId, successCB = null }) => {
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const { request } = useApiRequest();

  const handleDrop = (e) => {
    e.preventDefault();
    let file = e?.dataTransfer?.files?.[0] || null;
    const allowedExtension = /\.csv$/i;
    if (!allowedExtension.test(file?.name)) {
      toast.error("❌ Only CSV files are allowed.", { autoClose: 3000 });
      file = null; // Clear the file input
      return;
    }
    if (file) uploadFile(file);
  }

    const uploadFile = (file) => {
      if(file) {
        const formData = new FormData();
        formData.append("file", file);
        let url = appApis.uploadCompaniesCsv;
        if(fileName == "vehicle-gps") url = appApis.uploadVehicleCsv;
        else if(fileName.includes("inventories")) {
          url = appApis.uploadInventoryCsv;
          formData.append("inventoryTypeId", inventoryTypeId);
        } else if(fileName == "mapping") url = appApis.mappingCsv;

        request({
          url,
          method: "POST",
          body: formData,
          config: { "Content-Type": "multipart/form-data" },
          onSuccess: () => {
            setError([]);
            if(fileName == "companies") dispatch(getCompanies());
            if(successCB) successCB();
          },
          onError: (errResponse) => {
            setError(errResponse);
          }
        })
      }
    }

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) uploadFile(e.target.files[0]);
    }

    const handleClick = () => {
        if(fileInputRef?.current) fileInputRef.current.click();
    }

    return <>
        <input type="file" ref={fileInputRef} onChange={handleFileChange} id="csvFileInput" accept=".csv" className="d-none" />
        <div className="py-5 px-2 text-center" id="drop-zone" onClick={handleClick} onDragOver={(e) => e.preventDefault()} onDrop={handleDrop}>
            <MdOutlineFileUpload fontSize={60} />

            <p className="mb-3">Drop your CSV file here or click to browse.</p>
            <ButtonElement text={<span><MdOutlineFileDownload fontSize={20} />{" "}Download Template</span>} cssClass="small-radius me-1 mb-1" onClick={(e) => {
               e.stopPropagation();
               downloadFile(url,fileName)
             }} variant="btn-outline-grey" loading={false} />
        </div>
    </>
}

export default DropZone;